import React from 'react';
import { useI18n } from '@udemy/i18n/';
import styles from "./seo-links.module.css";
export const SeoLinks = ({
  navigationCategories,
  mostPopularSubcategories
}) => {
  const {
    gettext
  } = useI18n();
  return /*#__PURE__*/React.createElement("nav", {
    "aria-label": gettext('SEO links'),
    "aria-hidden": "true",
    className: styles['seo-nav']
  }, navigationCategories === null || navigationCategories === void 0 ? void 0 : navigationCategories.map(cat => {
    var _cat$children;
    return /*#__PURE__*/React.createElement(React.Fragment, {
      key: cat.id
    }, /*#__PURE__*/React.createElement("a", {
      "data-id": cat.id,
      className: "js-side-nav-cat",
      href: cat.absolute_url,
      tabIndex: -1
    }, cat.title), /*#__PURE__*/React.createElement("div", null, (_cat$children = cat.children) === null || _cat$children === void 0 ? void 0 : _cat$children.map(subcat => /*#__PURE__*/React.createElement("a", {
      "data-id": subcat.id,
      key: subcat.id,
      className: "js-side-nav-cat js-subcat",
      href: subcat.absolute_url,
      tabIndex: -1
    }, subcat.title))));
  }), mostPopularSubcategories === null || mostPopularSubcategories === void 0 ? void 0 : mostPopularSubcategories.map(subcat => {
    var _subcat$popularTopics;
    return /*#__PURE__*/React.createElement("div", {
      key: subcat.id,
      "data-id": subcat.id,
      className: "js-side-nav-popular-topics"
    }, (_subcat$popularTopics = subcat.popularTopics) === null || _subcat$popularTopics === void 0 ? void 0 : _subcat$popularTopics.map(topic => /*#__PURE__*/React.createElement("a", {
      key: topic.id,
      "data-id": topic.id,
      href: topic.absolute_url,
      tabIndex: -1
    }, topic.title)));
  }));
};
//# sourceMappingURL=seo-links.react-component.js.map